import { Header } from "@/components/Header";
import { ProductCard } from "@/components/ProductCard";
import { Button } from "@/components/ui/button";
import { categories, getProductsByCategory } from "@/lib/mockData";
import { useState } from "react";

export const Home = () => {
  const [selectedCategory, setSelectedCategory] = useState("all");

  const products = getProductsByCategory(selectedCategory);

  return (
    <div className="min-h-screen bg-background">
      <Header />

      {/* Hero Banner */}
      <section className="bg-gradient-to-r from-primary to-primary/80 text-white py-16 px-4">
        <div className="container mx-auto max-w-6xl text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Welcome to ShopHub
          </h1>
          <p className="text-lg text-white/90 max-w-2xl mx-auto">
            Discover amazing products handpicked just for you. Fast shipping, great prices, and exceptional quality.
          </p>
        </div>
      </section>

      {/* Categories Filter */}
      <section className="border-b border-border bg-muted/50">
        <div className="container mx-auto max-w-6xl px-4 py-6">
          <div className="flex flex-wrap gap-2">
            {categories.map((category) => (
              <Button
                key={category.id}
                variant={selectedCategory === category.id ? "default" : "outline"}
                onClick={() => setSelectedCategory(category.id)}
                className="rounded-full"
              >
                {category.name}
              </Button>
            ))}
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="container mx-auto max-w-6xl px-4 py-12">
        <h2 className="text-2xl font-bold mb-8">
          {categories.find((c) => c.id === selectedCategory)?.name || "All Products"}
        </h2>

        {products.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-muted-foreground">No products found in this category.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        )}
      </section>

      {/* Footer */}
      <footer className="border-t border-border bg-muted py-8 mt-12">
        <div className="container mx-auto max-w-6xl px-4 text-center text-muted-foreground">
          <p>&copy; 2024 ShopHub. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};
